@if(subContractorDetailData?.id || subContractorId){
<div class="p-2 p-lg-4">
  @if(isAdmin){
  <div class="text-end mb-3">
    <button
      class="btn btn-sm btn-outline-danger hover px-4"
      (click)="deleteContractor()"
    >
      Delete
    </button>
  </div>

  }
  <div class="d-flex flex-wrap row-gap-2 column-gap-5 mb-3">
    @for (field of ['company_name', 'full_address', 'mobile_number', 'email'];
    track $index) {
    <dl>
      <dt>
        @switch (field) { @case ('company_name') { Company Name } @case
        ('full_address') { Company Address } @case ('mobile_number') { Contact
        Number } @case ('email') { Contact Mail } }
      </dt>
      @if(subContractorDetailData?.[field]){
      <dd
        [class.link-edit]="isAdmin"
        (click)="
              isAdmin ? openTemplate(updateContractorTemplateRef, field) : null
            "
      >
        {{ subContractorDetailData?.[field] }}
      </dd>
      } @if (isAdmin && !subContractorDetailData?.[field]) {
      <div
        class="rounded border shadow p-2 mb-2 text-center hover"
        role="button"
        (click)="openTemplate(updateContractorTemplateRef, field)"
      >
        <i class="fa-solid fa-plus"></i>
      </div>
      }
    </dl>
    }
  </div>

  <dl class="mb-3">
    <dt class="mb-1">Users</dt>

    <dd class="mb-2 d-flex flex-wrap gap-2">
      @for ( user of subContractorDetailData?.users; track user; let i = $index
      ) {
      <div
        class="d-flex flex-column flex-wrap border rounded p-3 mb-2 shadow gap-2"
      >
        <div class="fw-semibold">{{ user?.full_name }}</div>

        <div class="d-flex">{{ user?.email }}</div>
      </div>
      } @if (isAdmin) {
      <div
        class="d-flex align-items-center justify-content-center bg-secondary-subtle text-dark border rounded p-4 mb-2 shadow fw-semibold hover"
        role="button"
        (click)="openTemplate(addUserTemplate, 'users')"
      >
        Update
      </div>
      }
    </dd>
  </dl>
  <gtapp-identification
    showFrom="subContractorPage"
    [subContractorId]="subContractorDetailData?.id|| subContractorId"
  ></gtapp-identification>
</div>
}@else {
<div class="dialog-box card">
  <div class="card-header">
    Add New Subcontractor
    <span class="float-end" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  <form [formGroup]="contractorForm">
    @if (currentStep === 1) {
    <div class="row row-cols-2 gy-2 mb-2">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="onCloseDialogue()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          [disabled]="!contractorForm.value.company_name"
          class="btn btn-lg btn-primary w-100"
          (click)="userListNextCursor = ''; userListData = []; loadUserList();currentStep = 2 "
        >
          Next
        </button>
      </div>
    </div>

    <div class="d-flex flex-column gap-2">
      <gtapp-input-field
        dtValue="Company Name"
        inputId="companyNameField"
        [maxLength]="256"
        [inputStringValue]="contractorForm.value.company_name"
        (blurEmit)="
              contractorForm.controls['company_name'].setValue($event)
            "
      >
      </gtapp-input-field>

      <gtapp-address-lookup
        [addressForm]="addressForm"
        placeholder="Lookup Address (Optional)"
      >
      </gtapp-address-lookup>

      <div class="col-12 form-floating">
        <input
          class="form-control"
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          minlength="7"
          maxlength="10"
          (input)="mobileNumberCheck()"
          formControlName="mobile_number"
          id="mobile_number"
          placeholder="Telephone"
        />
        <label for="mobile_number">Telephone</label>
        @if ( contractorForm.controls["mobile_number"].invalid &&
        contractorForm.controls["mobile_number"].touched ) {
        <div class="text-danger">Invalid mobile number</div>
        }
      </div>
      <gtapp-input-field
        dtValue="Email"
        inputId="companyEmailField"
        inputFieldType="email"
        [maxLength]="64"
        [inputStringValue]="contractorForm.value.email"
        (blurEmit)="contractorForm.controls['email'].setValue($event)"
      >
      </gtapp-input-field>
    </div>
    } @if(currentStep==2){
    <div class="row row-cols-2 gy-2 mb-4">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="currentStep=1"
        >
          Back
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-primary w-100"
          [disabled]="!contractorForm.value.company_name"
          (click)="onCreateSubContractor()"
        >
          Submit
        </button>
      </div>
    </div>
    <ng-template *ngTemplateOutlet="selectUserTempalte"></ng-template>
    }
  </form>
</div>
}

<ng-template
  #updateContractorTemplateRef
  let-updateContractorTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      Update
      <span class="float-end" (click)="updateContractorTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <ng-container>
        <form [formGroup]="contractorForm" appFormEnterAction>
          @if (data?.field == "company_name") {
          <gtapp-input-field
            dtValue="Company Name"
            inputId="companyNameField"
            [maxLength]="256"
            [inputStringValue]="contractorForm.value.company_name"
            (blurEmit)="
              contractorForm.controls['company_name'].setValue($event)
            "
          >
          </gtapp-input-field>
          } @if (data?.field == "email") {
          <gtapp-input-field
            dtValue="Email"
            inputId="companyEmailField"
            inputFieldType="email"
            [maxLength]="64"
            [inputStringValue]="contractorForm.value.email"
            (blurEmit)="contractorForm.controls['email'].setValue($event)"
          >
          </gtapp-input-field>
          } @if (data?.field == "mobile_number") {
          <div class="col-12 form-floating">
            <input
              class="form-control"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              minlength="7"
              maxlength="10"
              (input)="mobileNumberCheck()"
              formControlName="mobile_number"
              id="mobile_number"
              placeholder="Telephone"
            />
            <label for="mobile_number">Telephone</label>
            @if ( contractorForm.controls["mobile_number"].invalid &&
            contractorForm.controls["mobile_number"].touched ) {
            <div class="text-danger">Invalid mobile number</div>
            }
          </div>
          } @if (data?.field == "full_address") {
          <gtapp-address-lookup [addressForm]="addressForm">
          </gtapp-address-lookup>
          }
        </form>
        <div class="row row-cols-2 gy-2 mt-4">
          <div class="col">
            <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
            <button
              type="button"
              class="btn btn-dark btn-lg w-100"
              (click)="updateContractorTemplateRef.close()"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              [disabled]="
                   data?.field == 'full_address'
                      ? !addressForm.valid
                      : !contractorForm.valid
                "
              (click)="updateContractor(data?.field); updateContractorTemplateRef.close()"
            >
              Submit
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #addUserTemplate let-addUserTemplateRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      Add/Remove Users
      <span class="float-end" (click)="addUserTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <ng-template *ngTemplateOutlet="selectUserTempalte"></ng-template>

    <div class="row row-cols-2 gy-2">
      <div class="col">
        <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="addUserTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
        <button
          type="button"
          class="btn btn-lg btn-primary w-100"
          (click)="updateContractor('users'); addUserTemplateRef.close()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #selectUserTempalte>
  <div class="mb-2 fw-semibold">Select User(s):</div>

  <div class="mb-1">
    <gtapp-auto-complete
      [data]="userLookupDataList"
      placeHolder="Guard Name"
      searchKeyword="full_name"
      [initialValue]="userSearchString"
      [itemTemplate]="assigneeListTemplate"
      (inputChanged)="searchUsers($event)"
      (selected)="addSelectedUser($event)"
    >
    </gtapp-auto-complete>
  </div>

  <ng-template #assigneeListTemplate let-item>
    <div>{{ item?.full_name }}</div>
  </ng-template>

  <div class="overflow-assignee mb-3" id="assigneeList">
    @for (assignee of userListData; track assignee) {

    <div
      class="d-flex gap-2 py-4 border-bottom border-secondary-subtle px-2 mb-1"
      (click)="addRemoveUser(assignee)"
      role="button"
    >
      <div class="form-floating">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="selectedUserIds.has(assignee?.id)"
        />
      </div>

      <div class="flex-grow-1">{{ assignee?.full_name }}</div>
    </div>

    }
  </div>
  @if(!isLoadingMoreUsers){
  <div class="d-flex justify-content-between">
    <div>
      @if(userListNextCursor){
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="loadUserList()"
      >
        Load More</button
      >}
    </div>
    <div class="d-flex gap-2" (click)="selectAll()" role="button">
      <div class="form-floating">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="selectedUserIds.size === userListData?.length"
        />
      </div>

      <div class="flex-grow-1">Select All</div>
    </div>
  </div>
  }
  <div class="text-end my-4 text-secondary small">
    Selected Users: {{selectedUserIds.size}}
  </div>
</ng-template>
